export default "__VITE_ASSET__d93cdea4__"